/* eslint-disable no-useless-catch */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiget } from '../../service/api';

export const fetchWAContactData = createAsyncThunk('fetchWAContactData', async () => {
    const userid = sessionStorage.getItem('user_id');
    const userRole = sessionStorage.getItem("userRole");
    try {
        const response = await apiget(`api/whatsapp/contacts`);
        return response?.data?.result;
    } catch (error) {
        throw error;
    }
});

const WAContactSlice = createSlice({
    name: 'WAcontactDetails',
    initialState: {
        data: [],
        isLoading: false,
        error: "",
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWAContactData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchWAContactData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
                state.error = "";
            })
            .addCase(fetchWAContactData.rejected, (state, action) => {
                state.isLoading = false;
                state.data = [];
                state.error = action.error.message;
            });
    },
});

export default WAContactSlice.reducer;